export default __webpack_public_path__ + "static/media/plt1.a712cacc.png";